import React, { useEffect, useState } from 'react';
import { useTranslations } from 'hooks/useTranslations';
import { StyledPageTitle } from 'theme/styles';
import Breadcrumbs from 'components/atoms/Breadcrumbs';
import { ERouteLinks } from 'models/route';
import { useNavigate, useParams } from 'react-router-dom';
import { Loader } from 'components/atoms/Loader';
import LicenceAuthorityForm from '../LicenceAuthorityForm';
import { ILicenceAuthorityFormValues } from 'models/licenceAuthority';
import { initialFormValues } from '../helpers';
import { useLicenceAuthorities } from '../hooks';
import { IFilePrev } from 'components/molecules/FormInputFile';
import { EMIMETypesLabel } from 'constants/MIMETypes';

const LicenceAuthorityEditPage = () => {
  const { t } = useTranslations();
  const navigate = useNavigate();
  const { id = '' } = useParams<{ id: string }>();
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [initFile, setInitFile] = useState<IFilePrev>();
  const [formValues, setFormValues] = useState<ILicenceAuthorityFormValues>(initialFormValues);
  const { getLicenceAuthorityData, editLicenceAuthority, licenceAuthority } =
    useLicenceAuthorities();

  const onSubmit = async (data: ILicenceAuthorityFormValues) => {
    setIsSubmitLoading(true);
    const res = await editLicenceAuthority(id, data);
    if (res) {
      navigate(ERouteLinks.DetailsLicenceAuthorities.replace(':id', id));
    }
    setIsSubmitLoading(false);
  };

  useEffect(() => {
    (async function init() {
      setIsLoading(true);
      getLicenceAuthorityData(id);
    })();
  }, [id]);

  useEffect(() => {
    if (licenceAuthority) {
      setFormValues({
        name: licenceAuthority.name,
        isActive: licenceAuthority.isActive,
        authorizedPersonName: licenceAuthority.authorizedPersonName,
        position: licenceAuthority.position,
        signatureAttachmentFile: null,
      });
      if (licenceAuthority?.signatureAttachmentUrl) {
        setInitFile({
          fileUrl: licenceAuthority?.signatureAttachmentUrl,
          type: licenceAuthority?.signatureAttachmentType as EMIMETypesLabel,
          name: licenceAuthority?.signatureAttachmentName,
        });
      }
      setIsLoading(false);
    }
  }, [licenceAuthority]);

  return (
    <>
      <Breadcrumbs
        items={[
          { label: t('module.administration.name'), route: ERouteLinks.Administration },
          { label: t('licenceAuthorities.header'), route: ERouteLinks.LicenceAuthorities },
          t('licenceAuthorities.editLicenceAuthority.header'),
        ]}
      />
      <StyledPageTitle variant="h4">
        {t('licenceAuthorities.editLicenceAuthority.header')}
      </StyledPageTitle>

      {isLoading ? (
        <Loader isLoading={true} />
      ) : (
        <LicenceAuthorityForm
          isSubmitLoading={isSubmitLoading}
          onSubmit={onSubmit}
          initialFormValues={formValues}
          initFile={initFile}
          isEdit
        />
      )}
    </>
  );
};

export default LicenceAuthorityEditPage;
